export default __webpack_public_path__ + "static/media/WM0370.34I-43144_-25802_0.01e8b5e5.jpg";